/**
 * Created by eriksundqvist on 31/10/16.
 */

import { connect } from 'react-redux';
import {
  setExpressPayment,
  setCouponId,
  setCoupon,
  clearCoupon
} from 'redux/modules/invoice/index';
import Offers from './offers';

function mapStateToProps (state) {
  return {
    expressPayment: state.invoice.expressPayment,
    couponId: state.invoice.couponId,
    rot: state.invoice.hsd.rot,
    rut: state.invoice.hsd.rut,
    customer: state.invoice.customerEntity,
    invoiceId: state.invoice.invoiceId
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setExpressPayment: (expressPayment) => dispatch(setExpressPayment(expressPayment)),
    setCouponId: (couponId) => dispatch(setCouponId(couponId)),
    setCoupon: (coupon) => dispatch(setCoupon(coupon)),
    clearCoupon: (coupon) => dispatch(clearCoupon(coupon))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Offers);



/** WEBPACK FOOTER **
 ** ./src/views/invoice-tool/offers/offers-container.js
 **/